import {formatReferenceCopy} from 'utils/typography';
import React from "react";

import Typography from "@mui/material/Typography";
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";

import {capitalizeFirst, numberWithSpaces} from "../../../../../../../../../../../utils/helpers";
import {COLORS} from "../../../../../../../../../../../config/constants";

import './documents.scss'

type Props = {
  document: HsCodeOutputItemDocumentPricesItem | BrokerOutputDocument
}

const Documents = ({ document } : Props ) => {

  // @ts-ignore
  const name = document?.document_name ?? document?.document_type?.name ?? '';

  // @ts-ignore
  const techReglament = document?.tech_reglament?.name || document?.tech_reglament;

  // @ts-ignore
  const price = document.price || document.document_price;

  // @ts-ignore
  const totalPrice = `${numberWithSpaces(price)} ${document?.currency}`;

  return <Accordion sx={{
    marginBottom: 0,
    background: 'inherit',
    boxShadow: 'none',
    '&.Mui-expanded': {
      marginBottom: 0
    }
  }} className='code-services'>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon/>}
      sx={{
        margin: '0',
        alignItems: 'start',
        padding: '24px',
        minHeight: 'auto',
        '&.Mui-expanded': {
          borderBottom: 'none',
          minHeight: 'auto',
          '.MuiAccordionSummary-content': {
            margin: '0',
          }
        },
        '.MuiAccordionSummary-expandIconWrapper': {
          marginLeft: '16px',
          color: COLORS.LIGHT_ACTION,
          'svg': {
            width: '24px',
            height: '24px',
          },
        },
        '.MuiAccordionSummary-content': {
          margin: '0',
        }
      }}
    >
      <div className='code-services__title'>
        <div>
          <Typography variant='subtitle1' sx={{
            fontWeight: 500,
            lineHeight: '24px',
            color: COLORS.BLACK_DARK,
          }}>
            {formatReferenceCopy(name)}
          </Typography>
          <Typography variant='body2' sx={{
            fontWeight: 400,
            color: COLORS.LIGHT_TEXT_DISABLED,
            letterSpacing: 0,
            lineHeight: '21px',
          }}>
            {techReglament && formatReferenceCopy(techReglament)}
          </Typography>
        </div>
        <Typography variant='subtitle1' sx={{
          fontWeight: 400,
          lineHeight: '24px',
          color: COLORS.BLACK_DARK,
          flexShrink: 0,
        }}>
          {/* @ts-ignore */}
          {totalPrice}
        </Typography>
      </div>
    </AccordionSummary>
    <AccordionDetails sx={{padding: '0 24px 24px'}}>
      <ul className='code-services__documents'>
        {document.documents?.map((documentItem, index) =>
          <li className='code-services__documentItem' key={index}>
            <Typography variant='body2' className='code-services__label' sx={{
              color: COLORS.LIGHT_TEXT_SECONDARY,
              lineHeight: '21px',
            }}>{formatReferenceCopy(documentItem.name)}</Typography>
            <Typography variant='body2' className='code-services__value' sx={{
              color: COLORS.BLACK_DARK,
              lineHeight: '21px',
            }}>{formatReferenceCopy((documentItem.value ? capitalizeFirst(documentItem.value) : totalPrice) || '')}</Typography>
          </li>
        )}
      </ul>
    </AccordionDetails>
  </Accordion>
}

export default Documents
